import React, { useContext } from 'react';
import Skeleton from 'react-loading-skeleton';
import { ThemeContext } from 'styled-components';

interface IFieldProps {
  value?: string | number | JSX.Element;
  error?: string;
  loading?: boolean;
  width?: number;
  height?: number;
  count?: number;
  tag?: string | typeof React.Fragment;
}

const Field: React.FC<IFieldProps> = ({
  width = 150,
  height = 15,
  count = 1,
  loading = false,
  value,
  error,
  tag = React.Fragment,
}: IFieldProps) => {
  const themeContext = useContext(ThemeContext);
  const CustomTag = tag as keyof JSX.IntrinsicElements;
  if (loading) {
    return <Skeleton count={count} width={width} height={height} />;
  } else {
    if (value) {
      return <CustomTag>{value}</CustomTag>;
    } else {
      return (
        <CustomTag
          style={{
            textTransform: 'capitalize',
            color: `${themeContext?.flag.indisponivel}`,
          }}
        >
          {error || 'indisponível'}
        </CustomTag>
      );
    }
  }
};

export default Field;
